/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The category of the permission.
*/
export enum PermissionCategory {
  PERMISSION_CATEGORY_GLOBAL_MANAGEMENT = 'GLOBAL_MANAGEMENT',
  PERMISSION_CATEGORY_VIEWING = 'VIEWING',
  PERMISSION_CATEGORY_OPERATION = 'OPERATION',
  PERMISSION_CATEGORY_ADMINISTRATION = 'ADMINISTRATION'
}
